import { createSelector } from '@reduxjs/toolkit';

import { LESSON_TYPES } from '../data/lessonTypes';
import findLessonByLessonType from '../utils/findLessonByLessonType';

const baseSelector = (state) => state.editSbatGroup;

export const editSbatGroupGroupContestModalStateSelector = (state) =>
  baseSelector(state).groupContestModalState;

export const editSbatGroupSelectedSbatGroupSelector = (state) =>
  baseSelector(state).selectedSbatGroup;

export const editSbatGroupContestLessonSelector = createSelector(
  (state) => baseSelector(state).selectedSbatGroup,
  (selectedSbatGroup) => {
    const lessons = selectedSbatGroup?.academy_topic?.lessons;
    const contestLesson = findLessonByLessonType({
      lessons,
      lessonType: LESSON_TYPES.contest,
    });

    return contestLesson;
  }
);

export const editSbatGroupInterviewbitTestsSelector = createSelector(
  editSbatGroupContestLessonSelector,
  (contestLesson) => {
    return contestLesson?.meta?.interviewbit_tests;
  }
);

export const editSbatGroupSelectedInterviewbitTestSelector = createSelector(
  editSbatGroupInterviewbitTestsSelector,
  (state) => baseSelector(state).selectedInterviewbitTest,
  (interviewbitTests, selectedInterviewbitTest) => {
    return interviewbitTests?.find(
      (interviewbitTest) =>
        interviewbitTest.test_id === selectedInterviewbitTest?.test_id
    );
  }
);

export const groupContestCourseTypeSelector = (state) =>
  baseSelector(state).groupContestCourseType;
